module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/checkbox_unchecked-83e235f07914f7b9ce69a2a6548d527f.svg";